import { MarketingLayout } from '@layouts/MarketingLayout'
import CommunicationPage from '@pages/marketing/CommunicationPage'
import FeaturedVenuesPage from '@pages/marketing/FeaturedVenuesPage'
import LoyaltyTiersPage from '@pages/marketing/LoyaltyTiersPage'
import PushNotificationsPage from '@pages/marketing/PushNotificationsPage'
import ReferralPage from '@pages/marketing/ReferralPage'
import { Navigate, RouteObject } from 'react-router-dom'

const marketingRoutes: RouteObject[] = [
  {
    element: <MarketingLayout />,
    children: [
      { path: 'campaigns', element: <PushNotificationsPage /> },
      { path: 'loyalty-tiers', element: <LoyaltyTiersPage /> },
      { path: 'referral', element: <ReferralPage /> },
      { path: 'featured-venue', element: <FeaturedVenuesPage /> },
      { path: 'communication', element: <CommunicationPage /> },
      { index: true, element: <Navigate to="campaigns" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
]

export default marketingRoutes
